import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}`

console.log(API_URL, "API_URL")

// Fetch tournaments for admin's trainers
export const fetchAdminTournaments = async (pageNo = 1, limit = 10) => {
    let accessToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.get(`${API_URL}custom/admin-fetch-tournaments`, {
            params: { pageNo, limit },
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching tournaments:', error);
        throw error;
    }
}

// Fetch users for admin's trainers
export const fetchAdminUsers = async (pageNo = 1, limit = 10) => {
    let accessToken = localStorage.getItem("accessToken");
    try {
        const response = await axios.get(`${API_URL}auth/admin-fetch-users`, {
            params: { pageNo, limit },
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
}

